import { restClient } from '../../client';
import { AppointmentSlotDuration, PsychAppointmentBookingSource, ServiceType } from '../../resources';


export type CreatePsychiatryAppointmentInput = {
  notes: string;
  time_start: string;
  provider_id: string;
  patient_id: string;
  service_type?: ServiceType;
  duration?: AppointmentSlotDuration;
  timezone?: string;
  source?: PsychAppointmentBookingSource;
};


export type CreatePsychiatryAppointmentOutput = {
  created: boolean;
  status: string;
  id?: string;
  error?: string;
};


export const createPsychiatryAppointment = restClient.createRequest<CreatePsychiatryAppointmentInput, CreatePsychiatryAppointmentOutput>({
  url: '/appointment/psychiatry/create',
  method: 'POST',
});
